export const API_PATH = {
    LOGIN_API: "/api/user/login",
    LOGOUT_API: "/api/user/logout",
    ME_API: "/api/user/me",
    FORGOT_PASSWORD: "/api/user/forgetPassword",
    RESET_PASSWORD: "/api/user/resetPassword",
    CREATE_CAMPAIGN: "/api/campaign/createCampaign",
    GET_CAMPAIGNS: "/api/campaign/getCampaigns",
    UPDATE_CAMPAIGN: "/api/campaign/updateCampaign",
    CHANGE_STATUS: "/api/campaign/updateStatus",
    CAMPAIGN_SUMMARY: "/api/campaign/summary",
    //franchise
    GET_FRANCHISE_LIST: "/api/franchise/list",
    CREATE_FRANCHISE: "/api/franchise/create",
    UPDATE_FRANCHISE: "/api/franchise/update",
    CHANGE_STATUS_FRANCHISE: "/api/franchise/updateStatus",
    FRANCHISE_SUMMARY: "/api/franchise/summary",
    AUTO_ALLOCATE: "/api/campaign/auto-allocate",
    SAVE_LSM_ALLOCATION: "/api/campaign/auto-allocate-bulk",
    //dashboard
    DASHBOARD: "/api/dashboard",
    //store
    GET_STORE_LIST: "/api/store/list",
    GET_STORE_LIST_FOR_VALIDATION: "/api/store/listForValidation",
    CREATE_STORE: "/api/store/create",
    UPDATE_STORE: "/api/store/update",
    CHANGE_STATUS_STORE: "/api/store/updateStatus",

    //billing group
    GET_ALL_BILLING_GROUP: "/api/billingGroup/getAll",
    CREATE_BILLING_GROUP: "/api/billingGroup/create",
    UPDATE_BILLING_GROUP: "/api/billingGroup/update",
    CHANGE_STATUS_BILLING_GROUP: "/api/billingGroup/updateStatus",
    //User
    GET_ALL_USER: "/api/user/getUsers",
    GET_USER_ROLES: "/api/user/getRoles",
    CREATE_USER: "/api/user/createUser",
    CHANGE_STATUS_USER: "/api/user/updateStatus",
    RESET_PASSWORD_USER: "/api/user/unlock",
    // FAQs
    FAQ_LIST: "/api/faq/getFaq",
    FAQ_CREATE: "/api/faq/create",
    FAQ_UPDATE: "/api/faq/update",
    // Notifications
    NOTI_LIST: "/api/notification/getNotifications",
    NOTI_UPDATE: "/api/notification/updateNotification",
    // audit trail
    AUDIT_TRAIL: "/api/audit-trail",
    // reports
    GET_REPORTS: "/api/reports/getReports",
    SEARCH_REPORT: "/api/reports/generateReport",
    // fund allocation
    GET_FUND_ALLOCATION: "/api/store/summary",
    SET_FUND_ALLOCATION: "/api/store/auto-allocate",
    SAVE_TABLE_ALLOCATION: "/api/store/auto-allocate-bulk",
    // information
    INFORMATION: "/api/information",
    // management
    GET_HOUSEKEEPING_STATUS: "/api/management/housekeeping/status",
    START_HOUSEKEEPING: "/api/management/housekeeping/start",
}